<template>
    <div class="fileinfo">
        <van-nav-bar :title="$route.query.name" @click-left="onClickLeft" left-arrow />
        <div v-show="pdfShow" id="PDFIframe2" class="PDFIframe" style="height:100vh;overflow: auto;"></div>
        <van-image style="width:100%;" contain v-show="imgShow" :src="imgUrl" @click="handClickIMG" />
        <video v-show="videoShow" controls :src="videoUrl" style="width:100%;height:95%"></video>
        <div v-show="ViewerShow" id="MyViewerDiv"></div>
        <div v-html="txtContent" v-show="textShow">{{ info.prfl07 }}</div>
    </div>
</template>
<script>
import Pdfh5 from "pdfh5";
import { Office2Pdf } from "@/api/index";
import { ImagePreview } from "vant";
export default {
    name: "fileinfo",
    data() {
        return {
            pdfh5: null,
            imgShow: false,
            pdfShow: false,
            imgUrl: null,
            videoShow: false,
            videoUrl: null,
            ViewerShow: false,
            ViewerUrl: null,
            info: {},
            txtContent: null,
            textShow: false,

        }
    },
    methods: {
        pathUrl() {
            if (this.$route.query.name.includes('png') ||
                this.$route.query.name.includes('jpg') ||
                this.$route.query.name.includes('jpg') ||
                this.$route.query.name.includes('gif')
            ) {
                this.imgUrl = this.info.prfl07;
                this.imgShow = true;
            } else if (this.$route.query.name.includes('txt')) {
                // const url = this.$store.state.baseUrl + this.info.prfl04
                const url = this.info.prfl07
                fetch(url).then(response => response.text())
                    .then(text => {
                        // 转换编码，假设文件不是UTF-8编码，而是GBK编码
                        // const convertedText = new TextEncoder().encode(text);
                        // const blob = new Blob([convertedText], { type: 'charset=utf-8' });
                        // const urls = URL.createObjectURL(blob);
                        // 使用转换后的URL设置iframe的src属性
                        // this.iframeUrl = url;
                        this.txtContent = text;
                        this.textShow = true;
                    });

            } else if (this.$route.query.name.includes('pdf')) {
                this.pdfShow = true;
                setTimeout(() => {
                    new Pdfh5("#PDFIframe2", {
                        pdfurl: this.info.prfl07 ? this.info.prfl07 : (this.$store.state.baseUrl + this.info.fpath)
                    });
                }, 300);
            } else if (this.$route.query.name.includes('dwg')) {
                this.ViewerUrl = this.$store.state.baseUrl + this.info.pjdr11;
                this.viewers(this.ViewerUrl)
                this.ViewerShow = true;
            } else {
                Office2Pdf({ sourcePath: this.info.prfl04 ? this.info.prfl04 : this.info.fpath }).then((res) => {
                    if (res.Code === 0) {
                        this.$Toast.fail(res.Message);
                    } else {
                        this.pdfShow = true;
                        setTimeout(() => {
                            new Pdfh5("#PDFIframe2", {
                                pdfurl: this.$store.state.baseUrl + res.Data
                            });
                        }, 300);
                    }
                });
            }
        },
        handClickIMG() {
            ImagePreview({
                images: [this.imgUrl]
            })
        },
        viewers(url) {
            var _this = this;
            //初始化
            var config = {
                extensions: [
                    "Autodesk.Viewing.ZoomWindow",
                    // "Autodesk.Viewing.Collaboration",
                ],
                disabledExtensions: {
                    measure: false,
                    section: false,
                },
                memory: {
                    limit: 32 * 1024, //32 GB
                },
            };
            var myViewerDiv = document.getElementById("MyViewerDiv");
            _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(
                myViewerDiv,
                config
            );
            var options = {
                document: url,
                language: "zh-HANS",
                env: "Local",
                offline: "true",
                useADP: false,
            };
            Autodesk.Viewing.Initializer(options, function onInitialized() {
                _this.viewer.start();
                _this.viewer.loadModel(options.document, {
                    isAEC: true,
                });
                _this.viewer.setTheme("light-theme");
                _this.viewer.addEventListener(
                    Autodesk.Viewing.TEXTURES_LOADED_EVENT,
                    function (event) {
                        //选择集
                        var json = Params.state.replace(/'/g, '"');
                        var jsonObject = JSON.parse(json);
                        _this.viewer.restoreState(jsonObject);
                    }
                );
            });
        },
        onClickLeft() {
            this.$router.go(-1);
        },
    },
    mounted() {
        this.info = this.$route.query.item;
        this.pathUrl()
    },
}
</script>
<style lang="scss" scoped>
.fileinfo {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    background-color: #f5f5f5;

    #MyViewerDiv {
        height: 95vh;
        width: 100%;
        position: absolute;
    }

    // .head {
    //     height: 6%;
    //     width: 50%;
    //     background: gray;
    //     position: relative;
    //     top: -10px;
    //     z-index: 99;
    // }
}

/deep/.viewerContainer .pinch-zoom-container {
    height: 100vh !important;
}

// /deep/.PDFIframe img {
//     height: 100vh !important;
// }</style>
